<div class="process">
  <h1 class="large bright text-center">{{ 'landing.process.title' | translate }}</h1>

  <div class="graph flex mb-4">
    <div class="graph-item">
      <div class="graph-item-image">
        <img src="/assets/imgs/product.png" />
      </div>
      <div class="graph-item-text">
        <h2 class="mb-3 mt-0 font-semibold">{{ 'landing.process.step1_title' | translate }}</h2>
        <span class="text-sm" [innerHTML]="'landing.process.step1_desc' | translate"></span>
      </div>
    </div>
    <div class="graph-item">
      <div class="graph-item-image">
        <img src="/assets/imgs/upload.png" />
      </div>
      <div class="graph-item-text">
        <h2 class="mb-3 mt-0 font-semibold white-space-nowrap">{{ 'landing.process.step2_title' | translate }}</h2>
        <span class="text-sm" [innerHTML]="'landing.process.step2_desc' | translate"></span>
      </div>
    </div>
    <div class="graph-item">
      <div class="graph-item-image">
        <img src="/assets/imgs/style.png" />        
      </div>
      <div class="graph-item-text">
        <h2 class="mb-3 mt-0 font-semibold">{{ 'landing.process.step3_title' | translate }}</h2>
        <span class="text-sm" [innerHTML]="'landing.process.step3_desc' | translate"></span>
      </div>
    </div>
    <div class="graph-item">
      <div class="graph-item-image">
        <img src="/assets/imgs/order.png" />        
      </div>
      <div class="graph-item-text">
        <h2 class="mb-3 mt-0 font-semibold">{{ 'landing.process.step4_title' | translate }}</h2>
        <span class="text-sm" [innerHTML]="'landing.process.step4_desc' | translate"></span>
      </div>
    </div>
  </div>
  <div class="text-center">
    <app-button customIconSrc="/assets/icons/magic-wand.svg" [shadow]="false" size="large" routerLink="project" fragment="top" [label]="'landing.process.cta' | translate"></app-button>
  </div>
</div>
